export class Etage {
    id: number;
    niveau_id: number;
    nom_niveau: string;
    dossier_intervention_id: number;
    croquis_id: number;

    public constructor(init?: Partial<Etage>) {
        Object.assign(this, init);
    }
}
